<template>
  <b-navbar toggleable="lg" type="dark" variant="dark">
    <b-navbar-brand to="/">Scorekeeper Wins!</b-navbar-brand>
    <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav>
        <b-nav-item v-if="loggedIn" to="/games"><b-button variant="primary" type="submit">Games <span class="badge badge-light">{{ activeGameCount }}</span></b-button></b-nav-item>
        <b-nav-item to="/new-game"><b-button variant="primary" type="submit">Start a Game</b-button></b-nav-item>
      </b-navbar-nav>
      <b-navbar-nav class="ml-auto"> 
        <b-nav-item to="/pricing">Pricing</b-nav-item>
        <b-nav-item-dropdown right v-if="loggedIn">
          <!-- Using 'button-content' slot -->
          <template v-slot:button-content>
            <span>{{account.user.firstName}}</span>
          </template>
          <b-dropdown-item to="/profile">Profile</b-dropdown-item>
          <b-dropdown-item to="/login">Sign Out</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item to="/register" v-if="!loggedIn">Sign Up</b-nav-item>
        <b-nav-item to="/login" v-if="!loggedIn">Login</b-nav-item>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'

export default {
  computed: {
    ...mapGetters('games', {
      activeGameCount: 'activeGameCount'
    }),
    ...mapState({
        loggedIn: state => state.account.status.loggedIn,
        account: state => state.account,
        users: state => state.users.all
    })
  },
  methods: {
    ...mapActions('account', [ 'logout']),
  }
}
</script>